export default {
	add_your_property: {
		en: "Add your Property",
		ar: "أضف عقارك",
	},
	didnt_find_property: {
		en: "Didn't find your Property? Add New",
		ar: "لم تجد عقارك؟ اضف جديد",
	},
	didnt_find_building_villa: {
		en: "Didn't find your Building / Villa? Add New",
		ar: "لم تجد المبنى / الفيلا الخاصة بك؟ اضف جديد",
	},
	didnt_find_building: {
		en: "Didn't find your Building? Add New",
		ar: "لم تجد المبنى الخاص بك؟ اضف جديد",
	},
	didnt_find_villa: {
		en: "Didn't find your Villa? Add New",
		ar: "لم تجد فيلتك؟ اضف جديد",
	},
	didnt_find_unit: {
		en: "Didn't find your Unit? Add New",
		ar: "لم تجد وحدتك؟ اضف جديد",
	},
	add_your_property_success: {
		en: "Your Property has been added successfully.\nYou can add more properties or create a Tenancy Contract on the added property.",
		ar: "تمت إضافة عقارك بنجاح. \\ يمكنك إضافة المزيد من العقارات أو إنشاء عقد إيجار على العقار المضاف.",
	},
	add_more_properties: {
		en: "Add More Properties",
		ar: "أضف المزيد من العقارات",
	},
	create_tenancy_contract: {
		en: "Create Tenancy Contract",
		ar: "إنشاء عقد إيجار",
	},
	add_property_info: {
		en: "To add a property to the Land, please select Building / Villa from the list below. To view the units, first select the building.",
		ar: "لإضافة عقار إلى الأرض ، يرجى تحديد مبنى / فيلا من القائمة أدناه. لعرض الوحدات ، حدد المبنى أولاً.",
	},
	add_property_buildings: {
		en: "Building/s",
		ar: "مبنى",
	},
	add_property_villas: {
		en: "Villa/s",
		ar: "فيلا",
	},
	view_units: {
		en: "View Units",
		ar: "عرض الوحدات",
	},
	units_in: {
		en: "Units in ~",
		ar: "وحدات في ~",
	},
	total_no_units: {
		en: "Total ~ Units",
		ar: "إجمالي ~ الوحدات",
	},
	change: {
		en: "Change",
		ar: "تغيير",
	},
	building_and_unit: {
		en: "Building and Unit",
		ar: "بناء ووحدة",
	},
	add_building_or_villa: {
		en: "Add Building / Villa",
		ar: "اضافة مبنى / فيلا",
	},
	add_building_and_unit: {
		en: "Add Building and Unit",
		ar: "أضف مبنى ووحدة",
	},
	add_property: {
		en: "Add Property",
		ar: "إضـــافة عقار",
	},
	building_blocked_info: {
		en: "You cannot add units to this building as its blocked",
		ar: "لا يمكنك إضافة وحدات لهذا المبنى لأنها محظورة.",
	},
};
